import { ResetPassword } from '@artegeie/mrc/auth';
import { useNavigate } from 'react-router-dom';

import 'scss/components/content/account.scss';
import 'scss/components/content/_account-reset-password.scss';

export default function AccountResetPassword() {

	const queryParams = new URLSearchParams(window.location.search);
	const vtoken = queryParams.get('vtoken');

	const navigate = useNavigate();

	const onPassworCancel = () => {
		navigate( '/account-login', { trigger: true } );
	}

	return (

		<div id='account-page' className="account-reset-password">
			<ResetPassword resettoken={vtoken} onCancel={onPassworCancel}/>
		</div>
	);
};

